import * as actionTypes from "../constants/actionTypes";

const initialState = {
    colorantPackages: [],
    cart: {
        colorantPackages: []
    },
    databases: [],
    stockWarning: false
};

/**
 * Structure of barcode store:
 * - colorantPackages {Array}               - list of all colorant packages
 * - cart {Object}                          - cart for all orders that have been created but not sent yet
 * - databases {Array}                      - list of databases for all items in stock
 * - stockWarning {boolean}                 - true if there is shortage of some items in stock
 */
export const stockReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STOCK_CHECK_WARNING_STATUS:
            return {
                ...state,
                stockWarning: action.payload.colorantPackages.some((cp) => cp.minValue > cp.ordered + cp.currentValue)
            };
        case actionTypes.STOCK_SAVE_CART:
            return {
                ...state,
                cart: action.payload
            };
        case actionTypes.STOCK_SAVE_COLORANT_PACKAGES:
            return {
                ...state,
                colorantPackages: action.payload.colorantPackages,
                databases: action.payload.databases,
                stockWarning: action.payload.colorantPackages.some((cp) => cp.minValue > cp.ordered + cp.currentValue)
            };
        case actionTypes.STOCK_SAVE_WARNING:
            return {
                ...state,
                stockWarning: action.payload.stockWarning
            };
        case actionTypes.STOCK_RESET_CART:
            return {
                ...state,
                cart: {
                    colorantPackages: []
                }
            };
        case actionTypes.STOCK_RESET_COLORANT_PACKAGES:
            return {
                ...state,
                colorantPackages: [],
                databases: []
            };
        case actionTypes.DATABASE_CHANGE:
        case actionTypes.LOG_OUT_SUCCESS:
        case actionTypes.WEBSOCKET_CLOSED:
            return initialState;
        default:
            return state;
    }
};
